export default __webpack_public_path__ + "static/media/phone-1.f81edea1.png";